import React, { useState } from 'react';

import { extractErrorMessage } from '../components/EmailSectionHelpers';
import { authService } from '../services/authService';

interface ForgotState {
  success: boolean;
  loading: boolean;
  error: string | null;
}

const executePasswordReset = async (
  email: string,
  setState: React.Dispatch<React.SetStateAction<ForgotState>>
) => {
  try {
    await authService.forgotPassword(email);
    setState((p) => ({ ...p, success: true }));
  } catch (err: unknown) {
    setState((p) => ({ ...p, error: extractErrorMessage(err) }));
  } finally {
    setState((p) => ({ ...p, loading: false }));
  }
};

export const useForgotPassword = (email: string, onErrorClear?: () => void) => {
  const [state, setState] = useState<ForgotState>({ success: false, loading: false, error: null });

  const handleForgotPassword = async () => {
    if (!email.trim()) return;
    setState({ success: false, loading: true, error: null });
    if (onErrorClear) onErrorClear();
    await executePasswordReset(email, setState);
  };

  return {
    forgotSuccess: state.success, forgotLoading: state.loading, forgotError: state.error,
    setForgotSuccess: (success: boolean) => setState((p) => ({ ...p, success })),
    setForgotError: (error: string | null) => setState((p) => ({ ...p, error })),
    handleForgotPassword,
  };
};
